/*
  Spring Reset terms page: GA4 events. Loaded only on page.spring-reset-challenge-terms.

  Events (sent only to the GA4 property, not the Ads / other Google tags):
    src_terms_view          page view; arrived_clause is set when opened on a clause link
    src_terms_read_end      last clause scrolled into view, once per page view
    src_terms_cta_click     Weight Loss Reset button; cta_location top | bottom
    src_terms_form_click    entry or close-out form link; form entry | closeout
    src_terms_referral_click  Workout with a Friend link
    src_terms_fb_group_click  TRANSFORM Facebook group link
    src_terms_clause_click  clause heading link clicked; clause = anchor
    src_terms_link_click    any other link in the terms (e.g. privacy policy)
  Params on every event: terms_updated, site_market.

  Links inside clauses are authored in a rich-text setting and cannot carry data
  attributes, so the forms, referral page and Facebook group are recognised by URL.
*/
(function () {
  var root = document.querySelector('[data-src-terms]');
  if (!root) return;

  var GA4 = 'G-Y0VT2QGQW7';
  var ENTRY_FORM = 'E2yzG64Ter9poM9DbX8a';
  var CLOSEOUT_FORM = '1ybL38UlXW4HsUUDkrAY';
  var REFERRAL_PATH = '/pages/workout-with-a-friend';
  var FB_GROUP_PATH = 'facebook.com/groups/transformbyfitaz';

  var updatedEl = root.querySelector('[data-src-terms-updated]');
  var base = {
    terms_updated: updatedEl ? updatedEl.getAttribute('data-src-terms-updated') : '',
    site_market: root.getAttribute('data-market') || ''
  };

  window.dataLayer = window.dataLayer || [];
  function gtagCall() {
    if (typeof window.gtag === 'function') {
      window.gtag.apply(window, arguments);
    } else {
      window.dataLayer.push(arguments);
    }
  }

  function send(name, extra) {
    try {
      var params = { send_to: GA4 };
      for (var b in base) params[b] = base[b];
      if (extra) {
        for (var key in extra) params[key] = extra[key];
      }
      gtagCall('event', name, params);
    } catch (e) {}
  }

  function clauseFor(el) {
    var clause = el.closest('.src-terms__clause');
    var heading = clause && clause.querySelector('.src-terms__heading');
    return heading ? heading.id.replace(/^src-terms-/, '') : '';
  }

  var hash = window.location.hash;
  send('src_terms_view', {
    arrived_clause: hash.indexOf('#src-terms-') === 0 ? hash.slice('#src-terms-'.length) : ''
  });

  /* A scroll check rather than IntersectionObserver: a fast flick can carry the
     last clause from below the viewport to above it without it ever
     intersecting, and the observer reports nothing in that case. */
  var end = root.querySelector('[data-src-terms-end]');
  if (end) {
    var ticking = false;
    var checkEnd = function () {
      ticking = false;
      if (end.getBoundingClientRect().top < window.innerHeight) {
        send('src_terms_read_end');
        window.removeEventListener('scroll', onScroll);
      }
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(checkEnd);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  root.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var cta = link.getAttribute('data-src-terms-cta');

    if (cta) {
      send('src_terms_cta_click', { cta_location: cta, link_url: href, transport_type: 'beacon' });
    } else if (href.indexOf(ENTRY_FORM) !== -1 || href.indexOf(CLOSEOUT_FORM) !== -1) {
      send('src_terms_form_click', {
        form: href.indexOf(ENTRY_FORM) !== -1 ? 'entry' : 'closeout',
        clause: clauseFor(link),
        link_url: href,
        transport_type: 'beacon'
      });
    } else if (href.indexOf(REFERRAL_PATH) !== -1) {
      send('src_terms_referral_click', { clause: clauseFor(link), link_url: href, transport_type: 'beacon' });
    } else if (href.indexOf(FB_GROUP_PATH) !== -1) {
      send('src_terms_fb_group_click', { clause: clauseFor(link), link_url: href, transport_type: 'beacon' });
    } else if (link.closest('.src-terms__heading')) {
      send('src_terms_clause_click', { clause: clauseFor(link) });
    } else {
      send('src_terms_link_click', { clause: clauseFor(link), link_url: href, transport_type: 'beacon' });
    }
  }, true);
})();
